// skills/architecting/index.js
// Architecting skill registration with skill registry

import { skillRegistry } from '../../core/skillRegistry.js';
import {
    renderArchitectingUI,
    updateArchitectingUI,
    initArchitectingUI,
    toggleBlueprint,
    upgradeTool,
    switchTab,
    switchBlueprintTier,
    getCurrentTab,
    startMilestone,
    startQuickBuild,
    stopQuickBuild,
    startCivicContract,
    startNextPhase,
    confirmStopBlueprint,
    confirmSwitchBlueprint,
    confirmMilestoneSwitch,
    toggleAutoQueue
} from './architectingUI.js';

/**
 * Architecting skill configuration
 * Note: Tabs are managed internally (not via router) to preserve state when navigating away
 */
const architectingConfig = {
    id: 'architecting',
    name: 'Architecting',
    icon: '🏗️',
    iconImage: 'assets/icons/skill_icons/architecting.png',
    description: 'Build blueprints and town milestones',

    // No router-level tabs - architecting manages tabs internally to preserve state

    render(params = {}) {
        // Use persisted tab state if no tab specified in params
        const effectiveParams = {
            ...params,
            tab: params.tab || getCurrentTab()
        };
        renderArchitectingUI(effectiveParams);
    },

    update() {
        updateArchitectingUI();
    },

    init() {
        initArchitectingUI();
    },

    cleanup() {
        // Nothing to cleanup for now
    }
};

skillRegistry.register('architecting', architectingConfig);

if (typeof window !== 'undefined') {
    window.architectingUI = {
        toggleBlueprint,
        upgradeTool,
        switchTab,
        switchBlueprintTier,
        startMilestone,
        startQuickBuild,
        stopQuickBuild,
        startCivicContract,
        startNextPhase,
        confirmStopBlueprint,
        confirmSwitchBlueprint,
        confirmMilestoneSwitch,
        toggleAutoQueue
    };
}

export default architectingConfig;
